import vv_utils from './vv_utils';

/*-----------------------------------------------
|   Application Details
-----------------------------------------------*/

/* eslint-disable max-len*/

const supportInit_onStart = () => {

  const emailoption = document.getElementById("emailoption");
  const weboption = document.getElementById("weboption");
  const supportEmail = document.getElementById("supportEmail");
  const supportURL = document.getElementById("supportURL");

  if (window.vv_tenant_data.support_url) {
    weboption.classList.remove('d-none');
    supportURL.innerText = window.vv_tenant_data.support_url;
    supportURL.href = window.vv_tenant_data.support_url;
  }

  if (window.vv_tenant_data.support_email) {
    emailoption.classList.remove('d-none');
    supportEmail.innerText = window.vv_tenant_data.support_email;
  }  
}


export default {supportInit_onStart};
